import { render, staticRenderFns } from "./LastPurchase.vue?vue&type=template&id=fd39c6e0"
import script from "./LastPurchase.vue?vue&type=script&lang=js"
export * from "./LastPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports